module.exports = __webpack_public_path__ + "img/T6-B-12.fe57c8d1.png";